<template>
<v-layout>
    <v-col class="align-card-font">
        <v-row>
            <label class="card-title-font">{{brand.title}}</label>
        </v-row>
    </v-col>
    <v-menu left>
        <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
        </template>
        <v-list>
            <v-list-item v-for="(item, index) in icons" :key="index">
                <v-btn fab dark x-small class="ma-2" :style="theme">
                    <v-icon :show="isAllowed(item.permission)" @click="performAction(item,brand._id)">{{ item.name }}</v-icon>
                </v-btn>
            </v-list-item>
        </v-list>
    </v-menu>
</v-layout>
</template>

<script>
export default {
    props: ["brand","icons"],
};
</script>

